<template>
  <div id="contents">
    <div id="news" class="page_contents">
      <div id="news_contents">

        <div id="news_show" v-if="news">
          <div id="news_show_title">
            <h2><span>{{ news.date }}</span>{{ formatted_title(news.title) }}</h2>
          </div><!-- #news_show_title -->

          <div id="news_show_body">
            <!-- <p class="main_img"><img src="../assets/img/top/company_logo.jpg" /></p> -->
            <div id="news_show_body_contents" v-html="news.content"></div><!-- #news_show_body_contents -->
          </div><!-- #news_show_body -->

          <p class="page_close" v-if="!$parent.page_loading && referrer"><router-link v-bind:to="{name: referrer}"><img src="../assets/img/common/page/close_icon.png" width="50" alt="閉じるボタン" ></router-link></p>

          <p class="page_close" v-else-if="!$parent.page_loading"><router-link v-bind:to="{name: 'news_index'}"><img src="../assets/img/common/page/close_icon.png" width="50" alt="閉じるボタン" ></router-link></p>

        </div><!-- #news_show -->

      </div><!-- #news_contents -->

      <ul id="page_nav" v-if="news">
        <p v-if="news.next_post_id"><router-link v-bind:to="{name: 'news_show', params: {id: news.next_post_id}}"><img src="../assets/img/common/page/arrow.png" width="11" alt="右矢印" ></router-link></p>
        <p v-else></p>

        <p v-if="news.prev_post_id"><router-link v-bind:to="{name: 'news_show', params: {id: news.prev_post_id}}"><img src="../assets/img/common/page/arrow.png" width="11" alt="左矢印" ></router-link></p>
        <p v-else></p>
      </ul><!-- #page_nav -->
    </div><!-- #news -->



  </div><!-- #contents -->
</template>

<script>
export default {
  name: 'news_show',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/news/show.php',
      referrer: this.$attrs.referrer,
      news: null,
      error: null
    }
  },
  methods: {
    fetch_news(){
      this.$axios
        .get(this.api_url ,{
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          this.news = response.data.item[0]
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    formatted_title(title) {
      return title.replace(/<br\s*\/?>/g, '');
    }
  },
  watch: {
    '$route' (to, from) {
      this.fetch_news()
    }
  },
  mounted () {
    this.fetch_news()
  },
  updated (){
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/news_show.vue